<script lang="ts">
    import { faClipboard } from '@fortawesome/free-solid-svg-icons'
    import Fa from 'svelte-fa'
    import dayjs from 'dayjs'
    import 'dayjs/locale/pt-br'
    dayjs.locale('pt-br')
    import { createEventDispatcher } from 'svelte'
    import { ScheduleSlotStatus, type ScheduleSlot } from '../../../modules/schedulerApi/schedules/scheduleSlot'
    const dispatch = createEventDispatcher()

    export let slot: ScheduleSlot
    export let showTime = true
    export let heightPerMinute: number
    // janela de funcionamento da agenda (minutos do dia) — usada só para nomear a faixa indisponível
    export let openFrom: number = null
    export let openTo: number = null

    let minutes = 0
    let height = 0

    minutes = (+slot.end - +slot.start) / 1000 / 60
    height = heightPerMinute * minutes

    // faixas consecutivas inativas já chegam agrupadas num único slot (ver loadSlots), então o rótulo
    // aparece uma vez por faixa. Antes da abertura / depois do fechamento é "Fora do horário";
    // um buraco no meio do expediente é "Intervalo".
    const MIN_HEIGHT_TO_LABEL = 22
    $: slotMinute = slot.start.getHours() * 60 + slot.start.getMinutes()
    $: unavailable = slot.status === ScheduleSlotStatus.agendamento_desativado
    $: unavailableLabel =
        !unavailable || height < MIN_HEIGHT_TO_LABEL ? '' : openFrom === null || slotMinute < openFrom || slotMinute >= openTo ? 'Fora do horário' : 'Intervalo'

    export let selecting = false
    export let clear = false
    let selected = false

    $: {
        if (selecting) {
            selected = false
        }
    }
    $: {
        if (clear) selected = false
    }

    function hour(ap) {
        return ap.start.getMinutes() === 0
    }

    function bold(ap) {
        return ap.status !== 'agendamento_disponivel' && ap.status !== 'agendamento_bloqueado' && ap.status !== 'agendamento_desativado'
    }

    function onMouseDown(el) {
        dispatch('startSelecting', slot)
        selected = true
        if (window.$.copy) {
            pasting = true
        } else {
            pasting = false
        }
    }

    function onClick() {
        dispatch('click')
    }

    function onMouseOut(ev) {
        ev.target.scrollTop = 0
    }

    function onMouseMove(el) {
        if (selecting) {
            selected = true
        }
    }

    function onMouseUp() {
        if (selecting) {
            selected = true
            dispatch('stopSelecting', slot)
        }
    }

    let pasting = false
    async function goPaste() {
        pasting = false
        dispatch('paste', slot)
    }

    let over = false
    function onDragOver(ev) {
        if (slot.status === ScheduleSlotStatus.agendamento_bloqueado) return
        over = true
        ev.preventDefault()
    }
    function onDragLeave(ev) {
        over = false
    }
    function onDrop(ev) {
        if (slot.status === ScheduleSlotStatus.agendamento_bloqueado) return
        over = false
        goPaste()
        console.log('drop')
    }
</script>

<!-- O 1 extra no style abaixo é para compensar a border-bottom:1px -->
<div
    on:mouseleave={onMouseOut}
    on:blur={() => null}
    on:mousedown={onMouseDown}
    on:mousemove={onMouseMove}
    on:mouseup={onMouseUp}
    on:click={onClick}
    class="ap-slot scroll-dark {slot.status} h-print"
    class:selected
    class:over
    class:hour={hour(slot)}
    class:bold={bold(slot)}
    style="height:{height}px"
    on:dragover={onDragOver}
    on:dragleave={onDragLeave}
    on:drop={onDrop}
>
    <div class="header">
        {#if pasting && selected}
            <div class="act">
                <button title="Colar agendamento" on:mousedown|stopPropagation on:click|stopPropagation={goPaste}><Fa icon={faClipboard} /></button>
            </div>
        {/if}
        {#if showTime && !unavailable}
            <div class="time">{dayjs(slot.start).format('HH:mm')}</div>
        {/if}
    </div>
    {#if unavailableLabel}
        <div class="unavailable-label">{unavailableLabel}</div>
    {/if}
</div>

<style>
    .ap-slot {
        /* margin-top: 1px; */
        border-top: 1px solid #333333;
        width: 100%;
        font-size: 14px;
        cursor: pointer;
        position: relative;
    }
    .hour {
        border-top: 1px solid #282828;
    }
    .hour .time {
        color: #ddd;
    }
    .bold .time {
        color: #ddd;
    }
    .bold .header {
        background-color: #33333333;
    }
    /* mesmo tamanho do horário exibido dentro do agendamento (.ap-item_time) */
    .time {
        color: #aaa;
        font-size: 12px;
    }
    .ap-slot .time {
        padding: 0px 0px 0px 12px;
        cursor: pointer;
    }
    .ap-slot .header {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: flex;
    }

    /* rótulo sobreposto à hachura, centralizado na faixa inteira (a faixa é um único slot agrupado).
       pointer-events:none para não roubar o mousedown/drag de seleção do slot. */
    .unavailable-label {
        position: absolute;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        display: flex;
        align-items: center;
        justify-content: center;
        /* tipografia conforme CSS do designer (a família herda a Nunito do app: Inter não é carregada
           no projeto, então "Inter, sans-serif" cairia num fallback genérico diferente do resto da UI) */
        font-size: 11px;
        font-weight: 500;
        line-height: 1;
        letter-spacing: 0.02em;
        color: #7d7d7d;
        pointer-events: none;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        padding: 0px 6px;
    }
    :global(.theme_light) .unavailable-label {
        color: #a3aeaa;
    }
    .selected {
        background-color: #3f51b5 !important;
    }
    .paste {
        display: flex;
        justify-content: flex-end;
    }

    .act {
        align-items: center;
        justify-content: center;
        padding: 0px;
        flex-shrink: 0;
        position: absolute;
        right: 1px;
        top: 1px;
        overflow: hidden;
    }

    .act > button {
        width: 26px;
        height: 22px;
        padding: 0px;
        cursor: pointer;
        border: 0px solid #99999999;
        background: #333;
        margin-right: 1px;
        color: white;
    }
    .ap-slot .act button:hover {
        color: #2ecc71;
    }
    .over {
        background-color: #99999930;
    }

    @media print {
        .ap-slot {
            height: unset !important;
        }
    }
</style>
